import React from 'react';
import ReactDOM from 'react-dom/client';
import ClerkProviderWrapper from './ClerkProviderWrapper';
import App from './App';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ClerkProviderWrapper>
      <App />
    </ClerkProviderWrapper>
  </React.StrictMode>
);
